/**
 * Returns a formatted string containing the date day and time.
 *
 * @param {Date | String} date
 * @returns {String}
 */
export function formatDatetime(date, style = "short") {
  return toHumanDate(date, style, true);
}

/**
 * Returns a formatted string containing the date.
 *
 * @param {Date | String} date
 * @returns {String}
 */
export function formatDate(date, style = "short") {
  return toHumanDate(date, style, false);
}

const toHumanDate = (date, style, includeTime) => {
  if (!date) return "";

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  return date.toLocaleString(window._locale, { dateStyle: style, timeStyle: includeTime ? "short" : undefined });
};

export function initForAlpine(Alpine) {
  Alpine.magic("date", () => ({
    formatDatetime,
    formatDate,
  }));
}
